// DEPRECATED — rules moved to acorn_rules DB table (Admin → Acorns)
// isStreakMilestone() is still imported by useMemorySaved.ts.
// Safe to delete ACORN_RULES after next release.
export const ACORN_RULES = {
  /** First memory of the day (replaces memory_recorded, not in addition) */
  FIRST_MEMORY_OF_DAY: 3,
  /** Any subsequent memory same day */
  MEMORY_RECORDED: 1,
  /** Bonus for every 3-day streak milestone (3, 6, 9, 12...) */
  STREAK_MILESTONE: 3,
  /** Streak interval that triggers the milestone bonus */
  STREAK_MILESTONE_INTERVAL: 3,
} as const;

export function isStreakMilestone(streakDays: number): boolean {
  return streakDays > 0 && streakDays % ACORN_RULES.STREAK_MILESTONE_INTERVAL === 0;
}
